export default "__VITE_ASSET__C7Xna7SI__"